import { render } from "./SymbolsSearch.vue?vue&type=template&id=170ca1c2&scoped=true"
import script from "./SymbolsSearch.vue?vue&type=script&lang=js"
export * from "./SymbolsSearch.vue?vue&type=script&lang=js"

import "./SymbolsSearch.vue?vue&type=style&index=0&id=170ca1c2&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170ca1c2"]])

export default __exports__